
export default [
    {
        email: 'admin@qualitasequity.com',
        type: 'Bearer',
        accessToken: 'asd4673g1f2u7td8fyuihasd123',
        refreshToken: 'asd4673g1f2u7td8fyuihasd123',
        role: 'admin',
    },
    {
        email: 'anonymous@waavi.com',
        type: 'Bearer',
        accessToken: 'asd4673g1f2u7td8fyuihasd123',
        refreshToken: 'asd4673g1f2u7td8fyuihasd123',
        role: 'read',
    },
]
